import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { List } from 'immutable';
import { jsxActions as headerSettingsActions } from '../../../../actions/Header/headerSettingsActions';
import { jsxActions as settingsPageActions } from '../../../../actions/Administration/SettingsPage/settingsPageActions';
import { gridsNames } from '../../../../enums/gridsNames';
import TrucksSensorsView from '../../../../components/Administration/SettingsPage/IOTLogs/TrucksSensors/trucksSensorsView';
import { jsxActions as trucksSensorsViewActions } from '../../../../actions/Administration/SettingsPage/trucksSensorsViewActions';
import { jsxActions as trucksSensorsViewGridActions } from '../../../../actions/Administration/SettingsPage/trucksSensorsViewGridActions';
import {jsxActions as createTrucksSensorConfigDialogActions} from '../../../../actions/Administration/SettingsPage/Dialogs/createTrucksSensorConfigDialogActions';

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      ...bindActionCreators(trucksSensorsViewActions, dispatch),
      header: bindActionCreators(headerSettingsActions, dispatch),
      trucksSensorsViewGridActions: bindActionCreators(trucksSensorsViewGridActions, dispatch),
      createTrucksSensorConfigDialogActions : bindActionCreators(createTrucksSensorConfigDialogActions, dispatch),
      settingsPageActions: bindActionCreators(settingsPageActions, dispatch),
    },
  };
}

let TrucksSensorsViewContainer = connect(
  (state) => {
    let gridData = state.grid.get(gridsNames.ADMINISTRATION_SETTINGS_TRUCKS_SENSORS);
    let grid = gridData ? gridData : null;
    return {
      sGrid: grid,
      sHasRows: grid && grid.get('rows') ? grid.get('rows').size > 0 : false,
      sSelectedRowsData: grid ? grid.get('selectedRowsData') : List(),
      sCreateTrucksSensorConfigDialog: state.administration.getIn(['settingsPage', 'createTrucksSensorConfigDialog']),
      sData: state.administration.getIn(['settingsPage', 'trucksSensorsView']),
    };
  },
  mapDispatchToProps
)(TrucksSensorsView);

export default TrucksSensorsViewContainer;
